var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 51,
    viewBox: "0 0 71 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4892 20.2946C24.7525 21.4824 28.8694 18.4026 30.6844 13.4157C32.4995 8.42885 31.3254 3.42334 28.0621 2.23558C24.7988 1.04783 20.6819 4.12761 18.8668 9.11447C17.0518 14.1013 18.2258 19.1068 21.4892 20.2946Z",
    fill: "var(--main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8184 20.174C63.0383 18.8731 64.0369 13.8297 62.0489 8.9092C60.0609 3.98872 55.8391 1.05449 52.6192 2.35541C49.3993 3.65633 48.4007 8.69977 50.3887 13.6202C52.3767 18.5407 56.5985 21.475 59.8184 20.174Z",
    fill: "var(--main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4309 36.5508C58.0149 36.5508 70.7309 45.0568 70.7309 50.6218C69.2609 47.6088 50.7249 30.0278 14.2959 50.6218C14.2959 45.0568 26.8469 36.5508 42.4309 36.5508Z",
    fill: "var(--main-color)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.73,
    height: 50.622,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.5a1e0ba9bb5bc08003205ef8f9ad3749.svg";
export { ForwardRef as ReactComponent };